import React from 'react';
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer, Pagination, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, Select, MenuItem, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { getProposalProjectList } from 'ProposalProject/ProposalProject/Domain/Services/GetProposalProjectListService';
import { deleteProposalProject } from 'ProposalProject/ProposalProject/Domain/Services/DeleteProposalProjectService';
import { patchProposalProject } from 'ProposalProject/ProposalProject/Domain/Services/PatchProposalProjectService';
import { Delete, Edit, Restore, MoreHoriz } from '@mui/icons-material';
import { toast } from "react-toastify";
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { ADMIN_PROPOSAL_PROJECT_FORM, PRIVATE_PROPOSAL_PROJECT_FORM } from '../Constants/PathsConstant';
import { useTranslation } from 'react-i18next';
import Loader from 'UI/Application/Components/Loaders/Loader';
import { ADMIN_PROPOSAL_PROJECT, USER_PROPOSAL_PROJECT } from 'Shared/Security/Application/Constants/PermissionsConstant';
import { ProposalProjectConstants } from 'ProposalProject/ProposalProject/Domain/Model/ProposalProjectConstant';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Tooltip from '@mui/material/Tooltip';

function TableProposalProjectView() {
    const { t } = useTranslation();
    const { isAdmin, checkPermission } = useAuthContext();
    const [sendingApiRequest, setSendingApiRequest] = React.useState(false);
    // var readonly = true;
    // if (isAdmin()) {
    //   readonly = false;
    // }
    const limit = 10;
    const [offset, setOffset] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [lastPage, setLastPage] = React.useState(1);
    const [proposalProjectsRows, setProposalProjectsRows] = React.useState([]);
    const [proposalProjects, setProposalProject] = React.useState([]);
    const [loadProposalProjects, setLoadProposalProjects] = React.useState(true);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [openRestoreModal, setOpenRestoreModal] = React.useState(false);
    const [openDescriptionModal, setOpenDescriptionModal] = React.useState(false);
    const [selectedId, setSelectedId] = React.useState(null);
    const [selectedDescription, setSelectedDescription] = React.useState('');
    const [filterId, setFilterId] = React.useState('');
    const [filterTitle, setFilterTitle] = React.useState('');
    const [filterStatus, setFilterStatus] = React.useState('');
    const [filterDescription, setFilterDescription] = React.useState('');
    const [filterDeleted, setFilterDeleted] = React.useState(0);
    const [generatingPdf, setGeneratingPdf] = React.useState(false);

    React.useEffect(() => {
        if(loadProposalProjects){
            var data = {
                offset: offset,
                limit: limit
            };
            data = {
                ...data,
                filterId: filterId,
                filterTitle: filterTitle,
                filterStatus: filterStatus,
                filterDescription: filterDescription,
                filterDeleted: filterDeleted
            };

            getProposalProjectList(data).then((response) => {
                if(response !== null){
                    setProposalProject(response.records);
                    setLastPage(Math.ceil(response.total / limit));
                    setLoadProposalProjects(false);
                    if (Math.ceil(response.total / limit) < currentPage) {
                        setCurrentPage(Math.ceil(response.total / limit));
                        if (((Math.ceil(response.total / limit) - 1) * limit) < 0) {
                          setOffset(0);
                        } else {
                          setOffset((Math.ceil(response.total / limit) - 1) * limit);
                          setLoadProposalProjects(true);
                        }
                    }
                }
            });
        }

    }, [loadProposalProjects, offset, filterId, filterTitle,  filterStatus, filterDescription, filterDeleted]);

    const handleFilterIdChange = (event) => {
        const value = event.target.value.replace('PR-', ''); // Eliminar el prefijo PR-
        if (value === '' || /^\d*$/.test(value)) {
            setFilterId(value); // Actualizar solo con la parte numérica o vacío
            setOffset(0);
            setCurrentPage(1);
            setLoadProposalProjects(true); 
        }
    };

    const handleFilterTitleChange = (event) => {
        setFilterTitle(event.target.value);
        setOffset(0);
        setCurrentPage(1);
        setLoadProposalProjects(true);
    };

    const handleFilterStatusChange = (event) => {
        setFilterStatus(event.target.value);
        setOffset(0);
        setCurrentPage(1);
        setLoadProposalProjects(true);
    };

    const handleFilterDescriptionChange = (event) => {
        setFilterDescription(event.target.value);
        setOffset(0);
        setCurrentPage(1);
        setLoadProposalProjects(true);
    };

    // const handleFilterEnabledChange = (event) => {
    //     setFilterEnabled(event.target.value);
    //     setLoadProposalProjects(true);
    // };
    
    const handleFilterDeletedChange = (event) => {
        setFilterDeleted(event.target.value);
        setOffset(0);
        setCurrentPage(1);
        setLoadProposalProjects(true);
    };

    const handleDeleteProposalProject = (id) => {
        setSelectedId(id);
        setOpenDeleteModal(true);
    };

    const handleRestoreProposalProject = (id) => {
        setSelectedId(id);
        setOpenRestoreModal(true);
    };

    const handleOpenDescription = (description) => {
        setSelectedDescription(description);
        setOpenDescriptionModal(true);
    };

    const handleCloseDescription = () => {
        setOpenDescriptionModal(false);
    };

    // Function to truncate text
    const truncateText = (text, maxLength = 100) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    const handleDownloadPdfReport = async () => {
        try {
            setGeneratingPdf(true);

            const archive = 'documents/proposalproject/guias/Manual_de_uso_Propuestas_Proyecto.pdf';
            const base64FileName = btoa(archive); 
            const response = await fetch("/api/v1/blob-storage/" + base64FileName);            

            if (response.headers.get('Content-Type')?.includes('application/pdf')) {
                // It's a PDF - download it
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const fileName = response.headers.get('Content-Disposition')?.split('filename=')[1]?.replace(/"/g, '') || 'Manual_uso_propuestas_proyecto.pdf';
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            } else {
                // It's likely an error response
                const errorData = await response.json();
                toast.error(`Error al generar el PDF: ${errorData.message || 'Error desconocido'}`);
            }
        } catch (error) {
            toast.error('Error al generar el informe de cierre');
            console.error(error);
        } finally {
            setGeneratingPdf(false);
        }
    };
    const handleConfirmDelete = () => {
        if(selectedId && !sendingApiRequest){
            setSendingApiRequest(true);
            deleteProposalProject(selectedId).then((response) => {
                if(response){
                    setOpenDeleteModal(false);
                    setLoadProposalProjects(true);
                    setSelectedId(null);
                    toast.success(t('proposalProject.messages.success'));
                }
            }).finally(() => {
                setSendingApiRequest(false);
            });
        }
    };
    const handleConfirmRestore = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            patchProposalProject(selectedId, {
                restoreProposalProject: true
            }).then((response) => {
                if (response) {
                    setOpenRestoreModal(false);
                    setLoadProposalProjects(true);
                    setSelectedId(null);
                    toast.success(t('proposalProject.messages.success'));
                }
            }).finally(() => {
                setSendingApiRequest(false);
            });
        }
    };

    React.useEffect(() => {
    const rows = proposalProjects.map((proposalProject) => (
        <TableRow key={proposalProject.id}>
            <TableCell align='center' sx={{ maxWidth: 80, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>PR-{proposalProject.id}</TableCell>
            <TableCell align='center' sx={{ maxWidth: 140, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{proposalProject.userOwnerName}</TableCell>
            <TableCell align='center' sx={{ maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{proposalProject.title}</TableCell>
            <TableCell align='center' sx={{ maxWidth: 120, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{t('proposalProject.status.'+proposalProject.status)}</TableCell>
            <TableCell
                align='center'
                sx={{
                    maxWidth: 320,
                    minWidth: 180,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'normal', // Permite varias líneas
                    wordBreak: 'break-word',
                    verticalAlign: 'middle',
                    position: 'relative',
                    paddingRight: 0
                }}
            >
                <span>
                    {truncateText(proposalProject.description)}
                </span>
                {proposalProject.description && proposalProject.description.length > 100 && (
                    <IconButton
                        size="small"
                        onClick={() => handleOpenDescription(proposalProject.description)}
                        
                    >
                        <MoreHoriz fontSize="small" />
                    </IconButton>
                )}
            </TableCell>
            <TableCell align='center' sx={{ maxWidth: 170, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {proposalProject.jiraEpicKey ? (
                    <Tooltip title={`Ver en Jira: ${proposalProject.jiraEpicKey}`}>
                        <Button
                            variant="contained"
                            color="primary"
                            href={`${process.env.REACT_APP_JIRA_BASE_URL}/browse/${proposalProject.jiraEpicKey}`}
                            target="_blank"
                            sx={{
                                maxWidth: 160,
                                minWidth: 80,
                                fontSize: '0.85rem',
                                padding: '4px 8px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                            startIcon={<OpenInNewIcon />}
                        >
                            {proposalProject.jiraEpicKey}
                        </Button>
                    </Tooltip>
                ) : (
                    '-'
                )}
            </TableCell>
            <TableCell align="center" sx={{ width: 120 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                {proposalProject.deletedAt === null ? (<>
                    {
                    !([ProposalProjectConstants.STATUS_ACCEPTED, ProposalProjectConstants.STATUS_REFUSED].includes(proposalProject.status))
                    && 

                    (
                        checkPermission(ADMIN_PROPOSAL_PROJECT)
                        ||
                        checkPermission(USER_PROPOSAL_PROJECT)
                    )

                    && (
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => handleDeleteProposalProject(proposalProject.id)}
                            sx={{ minWidth: 36, padding: '6px' }}
                        >
                            <Delete />
                        </Button>
                    )
                    }
                    <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to={isAdmin() ? (`${ADMIN_PROPOSAL_PROJECT_FORM}/${proposalProject.id}`) : (`${PRIVATE_PROPOSAL_PROJECT_FORM}/${proposalProject.id}`)}
                        sx={{ minWidth: 36, padding: '6px' }}
                    >
                        <Edit />
                    </Button>
                </>) : (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleRestoreProposalProject(proposalProject.id)}
                        sx={{ minWidth: 36, padding: '6px' }}
                    >
                        <Restore />
                    </Button>
                )}
                </Box>
            </TableCell>
        </TableRow>
    ));
    setProposalProjectsRows(rows);
}, [proposalProjects]);

    // Update offset when page changes
    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
        if (((newPage - 1) * limit) < 0) {
        setOffset(0);
        } else {
        setOffset((newPage - 1) * limit);
        }
        setLoadProposalProjects(true);
    };

    // Create an array of status constants
    const statusOptions = Object.keys(ProposalProjectConstants)
        .filter(key => key.startsWith('STATUS_'))
        .map(key => ProposalProjectConstants[key]);

    return (
        <>
        <Box sx={{ p: 2 }}>
            <Typography variant="h4" align="center">{t('ui.menus.user.proposalProject')}</Typography>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', justifyContent: 'center', gap: 2, mt: 2 }}>
                <TextField
                    label={t('proposalProject.table.filter_by_id')}
                    variant="outlined"
                    value={filterId ? `PR-${filterId}` : ''}
                    onChange={handleFilterIdChange}
                    sx={{ width: { xs: '100%', md: 'auto' } }}
                />
                <TextField
                    label={t('proposalProject.table.filter_by_title')}
                    variant="outlined"
                    value={filterTitle}
                    onChange={handleFilterTitleChange}
                    sx={{ width: { xs: '100%', md: 'auto' } }}
                />
                <FormControl variant="outlined" sx={{ minWidth: {md: 200}, width: { xs: '100%', md: 'auto' } }}>
                    <Select
                        value={filterStatus}
                        onChange={handleFilterStatusChange}
                        displayEmpty
                        inputProps={{ 'aria-label': 'filter by status' }}
                    >
                        <MenuItem value="">{t('proposalProject.table.filter_by_status')}</MenuItem>
                        {statusOptions.map((status) => (
                            <MenuItem key={status} value={status}>
                                {t(`proposalProject.status.${status}`)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    label={t('proposalProject.table.filter_by_description')}
                    variant="outlined"
                    onChange={handleFilterDescriptionChange}
                    value={filterDescription}
                    sx={{ width: { xs: '100%', md: 'auto' } }}
                />
                {checkPermission(ADMIN_PROPOSAL_PROJECT) && (
                <FormControl variant="outlined" sx={{ minWidth: {md: 200}, width: { xs: '100%', md: 'auto' } }}>
                    <Select
                        value={filterDeleted}
                        onChange={handleFilterDeletedChange}
                        displayEmpty
                        inputProps={{ 'aria-label': 'filter by deleted status' }}
                    >
                        <MenuItem value={0}>{t('proposalProject.table.filter_by_deleted_not_deleted')}</MenuItem>
                        <MenuItem value={1}>{t('proposalProject.table.filter_by_deleted_deleted')}</MenuItem>
                        <MenuItem value={2}>{t('proposalProject.table.filter_by_deleted_all')}</MenuItem>
                    </Select>
                </FormControl>
                )}
            </Box>

            {(
                checkPermission(ADMIN_PROPOSAL_PROJECT)
                ||
                checkPermission(USER_PROPOSAL_PROJECT)
            ) && (
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row' }, alignItems: 'center', justifyContent: { xs: 'center', sm: 'space-between' }, mt: 4, gap: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to={isAdmin() ? (`${ADMIN_PROPOSAL_PROJECT_FORM}/new`) : (`${PRIVATE_PROPOSAL_PROJECT_FORM}/new`)}
                        sx={{ width: { xs: '100%', sm: 'auto' } }}
                    >
                        {t('proposalProject.table.button.requestForProjects')}
                    </Button>
                    
                    {generatingPdf && (
                        <Box
                            sx={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100vw',
                                height: '100vh',
                                bgcolor: 'rgba(255,255,255,0.5)',
                                zIndex: 2000,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Loader size={64} color="primary" />
                        </Box>
                    )}
                    
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleDownloadPdfReport}
                        disabled={generatingPdf}
                        sx={{ width: { xs: '100%', sm: 'auto' } }}
                    >
                        {t('proposalProject.table.button.downloadGuide')}
                    </Button>
                </Box>
            )}
            
            <TableContainer component={Paper} sx={{ mt: 2, overflowX: 'auto' }}>
                <Table sx={{ minWidth: 650 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align='center'>{t('proposalProject.table.id')}</TableCell>
                            <TableCell align='center'>{t('proposalProject.table.owner')}</TableCell>
                            <TableCell align='center'>{t('proposalProject.table.title')}</TableCell>
                            <TableCell align='center'>{t('proposalProject.table.status')}</TableCell>
                            <TableCell align='center'>{t('proposalProject.table.description')}</TableCell>
                            <TableCell align='center'>{t('proposalProject.table.jira')}</TableCell>
                            <TableCell align='center'>{t('proposalProject.table.actions')}</TableCell>                            
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {loadProposalProjects ? (
                            <TableRow>
                                <TableCell colSpan={100} align="center">
                                    <Loader />
                                </TableCell>
                            </TableRow>
                        ) : (
                            proposalProjectsRows
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                count={lastPage}
                page={currentPage}
                onChange={handlePageChange}
                sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}
            />

            <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
                <DialogTitle>{t('proposalProject.table.modal.delete.title')}</DialogTitle>
                <DialogContent>
                  <Typography variant="body1">{t('proposalProject.table.modal.delete.phrase')}</Typography>
                </DialogContent>
                <DialogActions>
                  <Button color="secondary" onClick={() => setOpenDeleteModal(false)}>{t('proposalProject.table.modal.delete.button.cancel')}</Button>
                  <Button variant="contained" color="error" onClick={handleConfirmDelete}>{t('proposalProject.table.modal.delete.button.delete')}</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openRestoreModal} onClose={() => setOpenRestoreModal(false)}>
                <DialogTitle>{t('proposalProject.table.modal.restore.title')}</DialogTitle>
                <DialogContent>
                  <Typography variant="body1">{t('proposalProject.table.modal.restore.phrase')}</Typography>
                </DialogContent>
                <DialogActions>
                  <Button color="secondary" onClick={() => setOpenRestoreModal(false)}>{t('proposalProject.table.modal.restore.button.cancel')}</Button>
                  <Button variant="contained" color="error" onClick={handleConfirmRestore}>{t('proposalProject.table.modal.restore.button.restore')}</Button>
                </DialogActions>
            </Dialog>
            
            {/* Description Modal */}
            <Dialog 
                open={openDescriptionModal} 
                onClose={handleCloseDescription}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>{t('proposalProject.table.description')}</DialogTitle>
                <DialogContent>
                    <Box sx={{ 
                        maxHeight: '60vh',
                        overflow: 'auto'
                    }}>
                        <Typography variant="body1" sx={{ 
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            width: '100%'
                        }}>
                            {selectedDescription}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDescription} color="primary">
                        {t('proposalProject.table.modal.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
        
        </>
    );
}

export default TableProposalProjectView;